import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { __EventDispatcher, __LocalStorage, __ProxiProvider, __UrlParams } from '../../../../_core/core';
import { EventClass, EventType } from '../../../config/Events';
import './Settings.styles.css';

const Settings = (_props: any) => {

	const [ isOpen, setIsOpen ] = useState<boolean>();
	const [ mute, setMute ] = useState<boolean>(__LocalStorage.isGlobalMuted());
 
	const onEventDispatched = (eventClass: EventClass, eventType: string, eventPayload: any) => {
		if (eventClass === EventClass.GUI) {
			switch (eventType) {
				case EventType.GUI.SHOW_SETTINGS:
					setIsOpen(true);
					break;

				case EventType.GUI.CLOSE_SETTINGS:
					setIsOpen(false);
					break;
 			}
		}
	}

	const setPageSettings = () => {
		if(isOpen) return { height: '100%'};
		else return { height: 0 };
	}

	const closeSettings = () => {
		__EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.CLOSE_SETTINGS, this);
	}

	const handleMuteCheckbox = (_event: any) => {
 		setMute(!mute);
	 
		__LocalStorage.muteSoundsBG(!mute);
		__LocalStorage.muteSoundsSFX(!mute);
		__LocalStorage.setVolumeMusic(!mute ? 0 : 1);
 	}

	useEffect(() => {
		__EventDispatcher.addListener(EventClass.GUI, onEventDispatched, this);
	}, []);

	useEffect(() => {
	  if(_props.drawStart) {  
      closeSettings();
    }  
  }, [_props.drawStart]);

	return (
		<div className="settings-overlay" style={ setPageSettings() }>
			<button className="closebtn" onClick={ () => closeSettings() }>
				<i className="fa-solid fa-xmark"></i>
			</button>
		 	<div className="settings-overlay-content">
				<div className="settings-overlay-row">
					<div className="settings-overlay-col">
						<input 
							className="apple-switch" 
							type="checkbox" 
							id="lbl_Checkbox"
							checked={ !mute }	
							onChange={handleMuteCheckbox}
						/>	
					</div>
					<div className="settings-overlay-col">
						<label htmlFor="lbl_Checkbox" className="settings-label">Sounds</label>
					</div> 
				</div>

				{ __UrlParams.props.lobbyURL ? (
				<div className="settings-overlay-row">
					<div className="settings-overlay-col">
						<button className="settings-icon" onClick={ () => __ProxiProvider.visitLobby() }>
						<i className="fa-solid fa-house"></i>
						</button>
					</div> 
					<div className="settings-overlay-col">
						<span className="settings-label">Lobby URL</span>
					</div>
				</div>): null }

				{ __UrlParams.props.historyURL ? (
					<div className="settings-overlay-row">
						<div className="settings-overlay-col">
							<button className="settings-icon" onClick={ () => __ProxiProvider.visitHistory() }>
								<i className="fa-solid fa-clock-rotate-left"></i>
							</button>
						</div> 
						<div className="settings-overlay-col">
							<span className="settings-label">History URL</span>
						</div>
					</div>) : null }

				{ __UrlParams.props.depositURL ? (
					<div className="settings-overlay-row">
						<div className="settings-overlay-col">
							<button className="settings-icon" onClick={ () => __ProxiProvider.visitCashier() }>
								<i className="fa-solid fa-coins"></i>
							</button>
						</div> 
						<div className="settings-overlay-col">
							<span className="settings-label">Cashier URL</span>
						</div>
					</div>
				): null }
			</div>		
		</div>
	)
}

const mapStateToProps = (state: any) => {
  return { 
    drawStart: state.game.GAMEPLAY.drawStart,  
  };
}

export default connect(mapStateToProps, {})(Settings);